import {config} from "../config";

export class CurrencyDenominator {

  public static ToMain(main: number): number {
    if (main) {
      return main / config.baseCurrencyDenomination;
    }
    return 0;
  }

  public static ToBase(base: number): number {
    if (base) {
      return base * config.baseCurrencyDenomination;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/CurrencyDenominator.ts